import { type SxProps, type Theme } from '@mui/system';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

export const courseTitle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  '& .admin-btn': {
    marginLeft: '18px',
    backgroundColor: '#006EC2',
    width: '100px',
    height: '25px',
    textTransform: 'capitalize',
  },
  '& .course-h': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
  },
};

export const courseCard: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  borderLeft: '2px solid #006EC2',
  boxShadow: '0px 3px 6px #00000029',
  padding: '10px',
};

export const courseActions: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  '& .heading-title': {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: '10px',
    cursor: 'pointer',
    marginRight: '40px',
  },
  '& .heading-title-all': {
    fontSize: '18px',
    marginLeft: '10px',
  },
  '& .heading-title-sort': {
    fontSize: '18px',
    marginLeft: '10px',
  },
  '& .course-search': {
    height: '35px',
    border: '1px solid #006EC2',
    width: '280px',
    outline: 'none !important',
    marginLeft: '10px',
    borderRadius: '3px',
    paddingRight: '35px',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'space-around',
    '& .heading-title': {
      marginRight: '5px',
    },
  },
};

export const cardSection1: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  '& .card-section1-content': {
    width: '90%',
    height: '80%',
    backgroundColor: '#F4FAFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [theme.breakpoints.down('md')]: {
    height: '150px',
  },
};

export const cardSection3: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  '& .complete-rate': {
    color: '#707070',
    fontSize: '17px',
    fontWeight: 'bold',
    margin: '7px 0px 0px 0px',
    textAlign: 'center',
  },
  '& .total-rate': {
    color: '#006EC2',
    margin: '4px 0px 0px 0px',
    fontWeight: 'bold',
    fontSize: '23px',
  },
  [theme.breakpoints.down('md')]: {
    height: 'auto',
  },
  '& .CircularProgressbar-text': {
    fontWeight: 'bold',
  },
};

export const cardSection2: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  '& .card-section2-main': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  '& .card-section2-h': {
    fontWeight: 'bold',
    textTransform: 'capitalize',
    fontSize: '28px',
    color: '#006EC2',
  },
  '& .badge': {
    marginLeft: '20px',
    color: '#fff',
    background: '#006EC2',
    fontSize: '13px',
    padding: '2px',
  },
  '& .card-section2-req': {
    marginLeft: '12px',
    fontSize: '12px',
    color: '#C20000',
  },
  '& .card-section2-desc': {
    fontSize: '18px',
  },
  '& .card-section2-span': {
    marginLeft: '27px',
  },
  '& .media-type': {
    textTransform: 'capitalize',
  },
  '& .line-breaker': {
    color: '#707070',
    height: '22px',
    width: '9px',
  },
};

export const courseDetailModal: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'max(400px, 45vw)',
  bgcolor: 'background.paper',
  paddingBottom: '20px',
  borderRadius: 0,
  '& .bi-p': {
    position: 'absolute',
    top: '42px',
    right: '40px',
    cursor: 'pointer',
  },
  '& .MuiDialogTitle-root': {
    color: '#006EC2',
    fontSize: '28px',
    fontWeight: 'bold',
    borderBottom: 'solid 2px #ECECEC',
    margin: '0px 30px 30px',
    padding: '34px 0px 15px',
  },
  '& .form-header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 2,
    color: '#006EC2',
  },

  '& form': {
    width: 'max(75%, 440px)',
    margin: 'auto',
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .form-element': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& label': {
        color: '#006EC2',
        fontSize: '1.125rem',
        marginRight: '16px',
      },

      '& .MuiSelect-select': {
        [theme.breakpoints.up('md')]: {
          width: '330px',
        },
        width: '250px',
        p: 1,
        border: 'none',
        outlineColor: '#006EC2',
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#006EC2',
        },
      },
    },
    '& .btn-container': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
};
